import React, { useMemo, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import WidgetsGrid from '../_layout/WidgetsGrid';
import Page from '../_layout/Page';
import { hasPermsOnIndexesOrReceipts } from '../../services/rolesSvc';
import useUserContext from '../../hooks/useUserContext';
import useAPI from '../../hooks/useAPI';
import useNavProject from '../../hooks/useNavProject';
import { getProjectTypeText, getSectionLinkPart } from '../../helpers/typeProject';

export default function ProjectReport() {
  const api = useAPI();
  const { stratId } = useParams();
  const location = useLocation();
  const userCtx = useUserContext();
  const navProject = useNavProject();

  const sectionLinkPart = useMemo(() => getSectionLinkPart(location.pathname), [location.pathname]);

  const typeProject = useMemo(() => getProjectTypeText(sectionLinkPart), [sectionLinkPart]);

  const setProjectTitle = useMemo(() => {
    switch (sectionLinkPart) {
      case 'policies':
        return navProject.setPolicyTitle;
      case 'goals':
        return navProject.setGoalTitle;
      case 'techs':
        return navProject.setTechTitle;
      case 'strats':
        return navProject.setStratTitle;
      default:
        return navProject.setStratTitle;
    }
  }, [sectionLinkPart, navProject]);

  useEffect(async () => {
    const result = await api.get(`/mng/strategies/${stratId}`);
    setProjectTitle(result.name);
  }, []);

  const widgets = useMemo(() => [
    { name: 'Реестр отчётов', url: `/${sectionLinkPart}/${stratId}/report/reports` },
    { name: `Унифицированные показатели проектов ${typeProject}`, url: `/${sectionLinkPart}/${stratId}/report/unified`, show: () => hasPermsOnIndexesOrReceipts(userCtx, { stratId }) },
    { name: `Вехи ${typeProject}`, url: `/${sectionLinkPart}/${stratId}/report/milestones` },
    { name: 'Поступления от научной и иновационной деятельности', url: `/${sectionLinkPart}/${stratId}/report/receipts` },
  ], [stratId, sectionLinkPart, typeProject]);

  return (
    <Page header={`Отчет по ${typeProject}`} className={`${sectionLinkPart}-page`}>
      <WidgetsGrid items={widgets.filter((w) => !w.show || w.show(userCtx.perms))} />
    </Page>
  );
} 